import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components/lib/Image";
import className from "./style.module.scss";

/**
 * TooltipButton :
 *  - Component renders a single button in ControlsTooltip
 */
export const TooltipButton = React.forwardRef((props, ref) => {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(e);
    }
  };

  const renderContent = () => {
    if (props.label) {
      return <p>{props.label}</p>;
    } else {
      return <Image src={props.image} alt={props.altText} />;
    }
  };

  return (
    <div
      ref={ref || props.buttonRef}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={className.controlsTooltip_item}
      aria-label="Controls Tooltip Item"
      data-title={props.label || props.altText}
    >
      {renderContent()}
    </div>
  );
});

TooltipButton.propTypes = {
  /**
   * Label for button [ if passed in turns component to p tag else render img tag]
   */
  label: PropTypes.string,
  /**
   * Image to be displayed on the item
   */
  image: PropTypes.string,
  /**
   * Function to invoke when item is clicked
   */
  onClick: PropTypes.func,
  /**
   * Ref callback to the button element
   */
  buttonRef: PropTypes.func,
};
